<template lang="pug">
select#subject_id.form-control(v-if="this.selectedSubject === undefined", @change='onSubjectChange($event)', v-model='defaultSubject' required)
  option(disabled value='0') Chọn
  option(v-for='o in filterSubject' :value='o.id') {{o.name}}
select#subject_id.form-control(v-else, @change='onSubjectChange($event)', v-model='selected' required)
  option(disabled value='0') Chọn
  option(v-for='o in filterSubject' :value='o.id') {{o.name}}
</template>

<script>
export default {
  props: {
    selectedSubject: Number,
    subjects_id: Array,
    subjects: Array
  },
  data() {
    return {
      defaultSubject: this.subjects_id ? parseInt(this.subjects_id[0]) : 0
    }
  },
  methods: {
    onSubjectChange(e) {
      var id = e.target.value
      this.$emit('onSubjectChange', id)
    }
  },
  computed: {
    filterSubject() {
      return this.subjects
    },
    selected() {
      return this.selectedSubject
    }
  }
}
</script>



// WEBPACK FOOTER //
// itemSubject.vue?07228a7a